import type { JSX } from 'react'
import { createStore } from 'zustand/vanilla'

export type PreloadedItemsState = {
	preloadedItemIndexSet: Set<number>
	items: JSX.Element[]
}

export type PreloadedItemsActions = {
	addItem: (item: JSX.Element, idx: number) => void
	clearItems: () => void
}

export type PreloadedItemsStore = PreloadedItemsState & PreloadedItemsActions

const FIRST_ITEM_INDEX = 0

export const createPreloadedItemsStore = () =>
	createStore<PreloadedItemsStore>()((set, get) => ({
		preloadedItemIndexSet: new Set<number>([FIRST_ITEM_INDEX]),
		items: [],
		addItem: (item, idx) => {
			if (get().preloadedItemIndexSet.has(idx)) {
				return
			}
			set((state) => ({
				items: state.items.concat(item),
				preloadedItemIndexSet: new Set(state.preloadedItemIndexSet).add(idx),
			}))
		},
		clearItems: () => set({ items: [] }),
	}))
